"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
exports.default = satcheljs_1.createStore('txpOption', {
    CreateEventsFromEmailAsPrivate: null,
    EventsFromEmailEnabled: null,
    Events: {
        DiningEventsFromEmailEnabled: null,
        EntertainmentEventsFromEmailEnabled: null,
        FlightEventsFromEmailEnabled: null,
        HotelEventsFromEmailEnabled: null,
        InvoiceEventsFromEmailEnabled: null,
        PackageDeliveryEventsFromEmailEnabled: null,
        RentalCarEventsFromEmailEnabled: null,
    },
})();
//# sourceMappingURL=store.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/calendar/owa-txp-option/lib/store/store.js
// module id = 3095
// module chunks = 2